import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Layout from '../components/Layout';

const s = {
  container: { padding: '24px', minHeight: '100vh', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', flexWrap: 'wrap', gap: '16px' },
  headerTitle: { fontSize: '24px', fontWeight: '700', color: '#f9fafb', margin: 0, display: 'flex', alignItems: 'center', gap: '10px' },
  statsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '12px', marginBottom: '24px' },
  statCard: { background: 'rgba(26, 32, 56, 0.8)', borderRadius: '12px', padding: '16px', border: '1px solid rgba(255,255,255,0.1)', cursor: 'pointer', transition: 'all 0.15s' },
  statLabel: { fontSize: '12px', color: '#9ca3af', marginBottom: '6px', fontWeight: '500' },
  statValue: { fontSize: '26px', fontWeight: '700', color: '#f9fafb', lineHeight: 1 },
  filtersRow: { display: 'flex', gap: '10px', marginBottom: '20px', flexWrap: 'wrap', alignItems: 'center' },
  input: { background: 'rgba(26,32,56,0.8)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '8px', padding: '10px 14px', color: '#f9fafb', fontSize: '14px', outline: 'none', boxSizing: 'border-box' },
  select: { background: 'rgba(26,32,56,0.8)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '8px', padding: '10px 14px', color: '#f9fafb', fontSize: '14px', outline: 'none', cursor: 'pointer', minWidth: '130px' },
  tableWrap: { background: 'rgba(26,32,56,0.8)', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.1)', overflow: 'auto' },
  table: { width: '100%', borderCollapse: 'collapse' },
  th: { padding: '12px 14px', textAlign: 'left', fontSize: '11px', fontWeight: '600', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid rgba(255,255,255,0.1)', background: 'rgba(18,24,47,0.5)', whiteSpace: 'nowrap' },
  td: { padding: '12px 14px', fontSize: '13px', color: '#d1d5db', borderBottom: '1px solid rgba(255,255,255,0.05)', verticalAlign: 'middle' },
  badge: { display: 'inline-block', padding: '3px 8px', borderRadius: '20px', fontSize: '11px', fontWeight: '600', whiteSpace: 'nowrap' },
  overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(10,14,39,0.9)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, backdropFilter: 'blur(4px)' },
  modal: { background: '#12182f', borderRadius: '16px', border: '1px solid rgba(255,255,255,0.1)', width: '90%', maxWidth: '750px', maxHeight: '85vh', overflow: 'auto', padding: '28px', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.7)', position: 'relative' },
  modalTitle: { fontSize: '20px', fontWeight: '700', color: '#f9fafb', marginBottom: '20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  label: { fontSize: '13px', color: '#9ca3af', marginBottom: '6px', display: 'block', fontWeight: '500' },
  row: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
  field: { marginBottom: '16px' },
  textarea: { width: '100%', background: 'rgba(26,32,56,0.8)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '8px', padding: '10px 14px', color: '#f9fafb', fontSize: '14px', outline: 'none', minHeight: '70px', resize: 'vertical', boxSizing: 'border-box', fontFamily: 'inherit' },
  btnP: { background: 'linear-gradient(135deg,#6366f1 0%,#8b5cf6 100%)', color: '#fff', border: 'none', borderRadius: '8px', padding: '10px 20px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' },
  btnS: { background: 'rgba(26,32,56,0.8)', color: '#d1d5db', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '8px', padding: '10px 20px', fontSize: '14px', fontWeight: '500', cursor: 'pointer' },
  btnD: { background: 'rgba(239,68,68,0.15)', color: '#ef4444', border: '1px solid rgba(239,68,68,0.3)', borderRadius: '8px', padding: '10px 20px', fontSize: '14px', fontWeight: '500', cursor: 'pointer' },
  tabBar: { display: 'flex', gap: 0, marginBottom: '20px', borderBottom: '2px solid rgba(255,255,255,0.1)' },
  tab: { padding: '10px 18px', fontSize: '13px', fontWeight: '600', cursor: 'pointer', color: '#9ca3af', background: 'none', border: 'none', borderBottom: '2px solid transparent', marginBottom: '-2px', transition: 'all 0.15s' },
  tabA: { color: '#818cf8', borderBottomColor: '#818cf8' },
  noteCard: { background: 'rgba(26,32,56,0.6)', borderRadius: '10px', padding: '14px', marginBottom: '10px', border: '1px solid rgba(255,255,255,0.06)' },
  qBtn: { border: 'none', borderRadius: '6px', padding: '4px 8px', fontSize: '13px', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '2px', whiteSpace: 'nowrap' },
  fuBadge: (type) => ({
    display: 'inline-block', padding: '2px 7px', borderRadius: '10px', fontSize: '10px', fontWeight: '700',
    ...(type === 'overdue' ? { background: 'rgba(239,68,68,0.2)', color: '#ef4444' } :
        type === 'today' ? { background: 'rgba(245,158,11,0.2)', color: '#f59e0b' } :
        type === 'soon' ? { background: 'rgba(59,130,246,0.15)', color: '#60a5fa' } : {})
  }),
  closeBtn: { background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', color: '#f9fafb', fontSize: '18px', cursor: 'pointer', borderRadius: '8px', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  pagination: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px', borderTop: '1px solid rgba(255,255,255,0.1)' },
};

const interestBadge = (l) => {
  const c = { hot: { bg: 'rgba(239,68,68,0.15)', color: '#ef4444', t: '🔥 ساخن' }, warm: { bg: 'rgba(245,158,11,0.15)', color: '#f59e0b', t: '🟡 دافئ' }, cold: { bg: 'rgba(59,130,246,0.15)', color: '#3b82f6', t: '🔵 بارد' } };
  const v = c[l] || c.warm;
  return <span style={{ ...s.badge, background: v.bg, color: v.color }}>{v.t}</span>;
};
const statusBadge = (st) => {
  const c = { new: { bg: 'rgba(99,102,241,0.15)', color: '#818cf8', t: 'جديد' }, contacted: { bg: 'rgba(59,130,246,0.15)', color: '#60a5fa', t: 'تم التواصل' }, demo_scheduled: { bg: 'rgba(139,92,246,0.15)', color: '#a78bfa', t: 'ديمو محجوز' }, demo_done: { bg: 'rgba(16,185,129,0.15)', color: '#34d399', t: 'ديمو تم' }, negotiation: { bg: 'rgba(245,158,11,0.15)', color: '#f59e0b', t: 'تفاوض' }, won: { bg: 'rgba(16,185,129,0.15)', color: '#10b981', t: '✅ كسبناه' }, lost: { bg: 'rgba(239,68,68,0.15)', color: '#ef4444', t: '❌ خسرناه' } };
  const v = c[st] || c.new;
  return <span style={{ ...s.badge, background: v.bg, color: v.color }}>{v.t}</span>;
};
const flag = (ph) => { if (!ph) return '🌍'; const p = ph.replace(/\D/g, ''); return p.startsWith('966') ? '🇸🇦' : p.startsWith('20') ? '🇪🇬' : p.startsWith('965') ? '🇰🇼' : p.startsWith('971') ? '🇦🇪' : '🌍'; };
const fmtDate = (d) => d ? new Date(d).toLocaleDateString('ar-EG', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : '-';
const fmtShortDate = (d) => d ? new Date(d).toLocaleDateString('ar-EG', { month: 'short', day: 'numeric' }) : '';
const API = process.env.REACT_APP_API_URL || '/api/v1';

const emptyNewLead = {
  customer_name: '', company_name: '', phone_number: '',
  email: '', interest_level: 'warm', industry: '',
  company_size: '', needs_summary: '', notes: '', source: 'manual'
};

// Add Lead Modal translations
const addLabels = {
  ar: {
    title: '➕ إضافة Lead جديد',
    customer_name: 'اسم العميل', ph_name: 'مثال: أحمد محمد',
    phone: 'رقم الهاتف', ph_phone: '966501234567',
    company: 'اسم الشركة', ph_company: 'مثال: شركة المتقدمة',
    email: 'البريد الإلكتروني', ph_email: 'email@company.com',
    interest: 'مستوى الاهتمام', industry: 'المجال / النشاط', ph_industry: 'مطاعم، تجارة، خدمات...',
    size: 'حجم الشركة', source: 'المصدر',
    needs: 'ملخص الاحتياج', ph_needs: 'وصف مختصر لاحتياج العميل...',
    notes: 'ملاحظات', ph_notes: 'أي ملاحظات إضافية...',
    cancel: 'إلغاء', save: '💾 حفظ Lead', saving: '⏳ جاري الحفظ...',
    hot: '🔥 ساخن', warm: '🟡 دافئ', cold: '🔵 بارد',
    choose: '-- اختر --',
    s1: '1-5 موظفين', s2: '6-20 موظف', s3: '21-50 موظف', s4: '51-100 موظف', s5: 'أكثر من 100',
    src_manual: 'إدخال يدوي', src_call: 'مكالمة هاتفية', src_wa: 'واتساب',
    src_web: 'الموقع الإلكتروني', src_ref: 'إحالة / توصية', src_social: 'سوشيال ميديا',
    src_expo: 'معرض', src_other: 'أخرى',
  },
  en: {
    title: '➕ Add New Lead',
    customer_name: 'Customer Name', ph_name: 'e.g. Ahmed Mohamed',
    phone: 'Phone Number', ph_phone: '966501234567',
    company: 'Company Name', ph_company: 'e.g. Advanced Co.',
    email: 'Email', ph_email: 'email@company.com',
    interest: 'Interest Level', industry: 'Industry', ph_industry: 'Restaurants, Retail, Services...',
    size: 'Company Size', source: 'Source',
    needs: 'Needs Summary', ph_needs: 'Brief description of customer needs...',
    notes: 'Notes', ph_notes: 'Any additional notes...',
    cancel: 'Cancel', save: '💾 Save Lead', saving: '⏳ Saving...',
    hot: '🔥 Hot', warm: '🟡 Warm', cold: '🔵 Cold',
    choose: '-- Select --',
    s1: '1-5 employees', s2: '6-20 employees', s3: '21-50 employees', s4: '51-100 employees', s5: '100+',
    src_manual: 'Manual Entry', src_call: 'Phone Call', src_wa: 'WhatsApp',
    src_web: 'Website', src_ref: 'Referral', src_social: 'Social Media',
    src_expo: 'Exhibition', src_other: 'Other',
  }
};

const LeadsPage = () => {
  const navigate = useNavigate();
  const [leads, setLeads] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedLead, setSelectedLead] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [saving, setSaving] = useState(false);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [interestFilter, setInterestFilter] = useState('');
  const [followUpFilter, setFollowUpFilter] = useState('');
  const [countryFilter, setCountryFilter] = useState('');
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({});
  const [modalTab, setModalTab] = useState('details');
  const [notes, setNotes] = useState([]);
  const [notesLoading, setNotesLoading] = useState(false);
  const [newNote, setNewNote] = useState('');
  const [addingNote, setAddingNote] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleting, setDeleting] = useState(false);
  // Follow-up
  const [fuDate, setFuDate] = useState('');
  const [fuNote, setFuNote] = useState('');
  const [fuSaving, setFuSaving] = useState(false);
  // Add Lead Modal
  const [showAddModal, setShowAddModal] = useState(false);
  const [newLead, setNewLead] = useState({ ...emptyNewLead });
  const [addingLead, setAddingLead] = useState(false);
  const [addError, setAddError] = useState('');
  const [addLang, setAddLang] = useState('ar');

  const t = addLabels[addLang];

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const fetchLeads = useCallback(async () => {
    try {
      setLoading(true);
      const p = new URLSearchParams({ page, limit: 20 });
      if (search) p.append('search', search);
      if (statusFilter) p.append('status', statusFilter);
      if (interestFilter) p.append('interest_level', interestFilter);
      if (followUpFilter) p.append('follow_up', followUpFilter);
      if (countryFilter) p.append('country_code', countryFilter);
      const res = await axios.get(`${API}/leads?${p}`, { headers });
      setLeads(res.data.data || res.data.leads || []);
      setPagination(res.data.pagination || {});
      if (res.data.stats) setStats(res.data.stats);
    } catch (err) { console.error('Fetch leads:', err); }
    finally { setLoading(false); }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, statusFilter, interestFilter, followUpFilter, countryFilter]);

  const fetchStats = async () => {
    try { const r = await axios.get(`${API}/leads/stats`, { headers }); setStats(r.data.data || r.data.stats); } catch (e) {}
  };

  useEffect(() => { fetchLeads(); fetchStats(); }, [fetchLeads]); // eslint-disable-line
  useEffect(() => { const tt = setTimeout(() => { setPage(1); fetchLeads(); }, 400); return () => clearTimeout(tt); }, [search]); // eslint-disable-line

  // Open lead
  const openLead = async (lead, tab = 'details') => {
    try {
      const r = await axios.get(`${API}/leads/${lead.id}`, { headers });
      const d = r.data.data || r.data.lead || r.data;
      setSelectedLead(d);
      setEditData({
        customer_name: d.customer_name || '', company_name: d.company_name || '',
        phone_number: d.phone_number || '', company_size: d.company_size || '',
        industry: d.industry || '', interest_level: d.interest_level || 'warm',
        interested_modules: d.interested_modules || '', budget_range: d.budget_range || '',
        needs_summary: d.needs_summary || '', status: d.status || 'new',
        source: d.source || '', demo_date: d.demo_date ? d.demo_date.slice(0, 16) : '',
      });
      setModalTab(tab); setShowModal(true); setShowDeleteConfirm(false);
      setNotes([]); setNewNote('');
      setFuDate(d.next_follow_up ? d.next_follow_up.slice(0, 16) : '');
      setFuNote(d.follow_up_note || '');
      if (tab === 'notes') fetchNotes(lead.id);
    } catch (err) { console.error(err); }
  };

  const saveLead = async () => {
    if (!selectedLead) return;
    try { setSaving(true); await axios.put(`${API}/leads/${selectedLead.id}`, editData, { headers }); setShowModal(false); fetchLeads(); fetchStats(); }
    catch (err) { alert('فشل في حفظ التعديلات'); }
    finally { setSaving(false); }
  };

  const handleDelete = async () => {
    if (!selectedLead) return;
    try { setDeleting(true); await axios.delete(`${API}/leads/${selectedLead.id}`, { headers }); setShowModal(false); setShowDeleteConfirm(false); fetchLeads(); fetchStats(); }
    catch (err) { alert(err.response?.data?.message || 'فشل الحذف'); }
    finally { setDeleting(false); }
  };

  // Quick status change from table
  const quickStatus = async (lead, newStatus, e) => {
    e.stopPropagation();
    try {
      await axios.patch(`${API}/leads/${lead.id}/status`, { status: newStatus }, { headers });
      fetchLeads(); fetchStats();
    } catch (err) { alert('فشل تغيير الحالة'); }
  };

  // WhatsApp
  const openWhatsApp = (lead, e) => {
    e.stopPropagation();
    const phone = (lead.phone_number || '').replace(/[^0-9]/g, '');
    if (!phone) return alert('لا يوجد رقم هاتف');
    axios.post(`${API}/leads/${lead.id}/log-contact`, { method: 'whatsapp' }, { headers }).catch(() => {});
    window.open(`https://wa.me/${phone}`, '_blank');
    fetchLeads();
  };

  // Follow-up
  const saveFollowUp = async () => {
    if (!fuDate || !selectedLead) return;
    try {
      setFuSaving(true);
      await axios.post(`${API}/leads/${selectedLead.id}/follow-up`, { follow_up_date: fuDate, note: fuNote }, { headers });
      setSelectedLead({ ...selectedLead, next_follow_up: fuDate, follow_up_note: fuNote });
      fetchLeads(); fetchStats();
      alert('تم جدولة المتابعة ✅');
    } catch (err) { alert('فشل في حفظ المتابعة'); }
    finally { setFuSaving(false); }
  };

  const completeFollowUp = async (setNext = false) => {
    if (!selectedLead) return;
    try {
      const body = setNext ? { next_follow_up: fuDate, next_note: fuNote } : {};
      await axios.post(`${API}/leads/${selectedLead.id}/follow-up/complete`, body, { headers });
      if (!setNext) { setFuDate(''); setFuNote(''); }
      fetchLeads(); fetchStats();
      alert('تمت المتابعة بنجاح ✅');
    } catch (err) { alert('خطأ'); }
  };

  // Book Demo
  const bookDemo = (lead, e) => {
    if (e) e.stopPropagation();
    const data = lead || selectedLead;
    if (!data) return;
    localStorage.setItem('booking_lead_data', JSON.stringify({
      lead_id: data.id,
      customer_name: data.customer_name || '',
      phone_number: data.phone_number || '',
      email: data.customer_email || '',
      company_name: data.company_name || '',
      needs_summary: data.needs_summary || '',
      interested_modules: data.interested_modules || '',
    }));
    setShowModal(false);
    navigate('/booking-calendar');
  };

  // Notes
  const fetchNotes = async (id) => { setNotesLoading(true); try { const r = await axios.get(`${API}/leads/${id}/notes`, { headers }); setNotes(r.data.notes || []); } catch (e) { setNotes([]); } finally { setNotesLoading(false); } };
  const handleTabChange = (tt) => { setModalTab(tt); if (tt === 'notes' && selectedLead && !notes.length) fetchNotes(selectedLead.id); };
  const addNote = async () => { if (!newNote.trim() || !selectedLead) return; try { setAddingNote(true); const r = await axios.post(`${API}/leads/${selectedLead.id}/notes`, { note: newNote.trim() }, { headers }); if (r.data.success) { setNotes(p => [r.data.note, ...p]); setNewNote(''); fetchLeads(); } } catch (e) { alert('فشل'); } finally { setAddingNote(false); } };
  const deleteNote = async (nid) => { if (!window.confirm('حذف؟')) return; try { await axios.delete(`${API}/leads/${selectedLead.id}/notes/${nid}`, { headers }); setNotes(p => p.filter(n => n.id !== nid)); fetchLeads(); } catch (e) { alert(e.response?.data?.message || 'فشل'); } };

  // Follow-up urgency label
  const fuLabel = (u) => u === 'overdue' ? '⏰ متأخر' : u === 'today' ? '📅 اليوم' : u === 'soon' ? '🔜 قريب' : '';

  // Add Lead Handler
  const handleAddLead = async () => {
    if (!newLead.phone_number && !newLead.customer_name) {
      setAddError(addLang === 'ar' ? 'يجب إدخال رقم الهاتف أو اسم العميل على الأقل' : 'Phone number or customer name is required');
      return;
    }
    setAddingLead(true);
    setAddError('');
    try {
      const res = await axios.post(`${API}/leads`, newLead, { headers });
      if (res.data.success) {
        setShowAddModal(false);
        setNewLead({ ...emptyNewLead });
        fetchLeads();
        fetchStats();
      } else {
        setAddError(res.data.message || 'Failed');
      }
    } catch (err) {
      setAddError(err.response?.data?.message || (addLang === 'ar' ? 'حدث خطأ في الاتصال' : 'Connection error'));
    }
    setAddingLead(false);
  };

  return (
    <Layout>
    <div style={s.container}>
      <div style={s.header}>
        <h1 style={s.headerTitle}>🛒 إدارة العملاء المحتملين (Leads)</h1>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <button
            onClick={() => { setShowAddModal(true); setNewLead({ ...emptyNewLead }); setAddError(''); }}
            style={{
              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
              color: '#fff', border: 'none', borderRadius: '10px',
              padding: '10px 22px', fontSize: '14px', fontWeight: '600',
              cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px',
              boxShadow: '0 4px 12px rgba(16,185,129,0.3)', transition: 'all 0.2s'
            }}
            onMouseOver={e => e.currentTarget.style.transform = 'translateY(-1px)'}
            onMouseOut={e => e.currentTarget.style.transform = 'translateY(0)'}
          >
            ➕ إضافة Lead
          </button>
          <span style={{ fontSize: '13px', color: '#9ca3af' }}>آخر تحديث: {new Date().toLocaleTimeString('ar-EG')}</span>
        </div>
      </div>

      {/* ===== STATS ===== */}
      {stats && (
        <div style={s.statsGrid}>
          <div style={s.statCard} onClick={() => { setFollowUpFilter(''); setStatusFilter(''); setPage(1); }}>
            <div style={s.statLabel}>إجمالي Leads</div>
            <div style={s.statValue}>{stats.total || 0}</div>
          </div>
          <div style={{ ...s.statCard, borderLeft: '3px solid #6366f1' }} onClick={() => { setFollowUpFilter(''); setStatusFilter(''); setPage(1); }}>
            <div style={s.statLabel}>اليوم</div>
            <div style={{ ...s.statValue, color: '#818cf8' }}>{stats.today || 0}</div>
          </div>
          <div style={{ ...s.statCard, borderLeft: '3px solid #ef4444' }} onClick={() => { setFollowUpFilter('overdue'); setStatusFilter(''); setPage(1); }}>
            <div style={s.statLabel}>⏰ متابعات متأخرة</div>
            <div style={{ ...s.statValue, color: '#ef4444' }}>{stats.overdue || 0}</div>
          </div>
          <div style={{ ...s.statCard, borderLeft: '3px solid #f59e0b' }} onClick={() => { setFollowUpFilter('today'); setStatusFilter(''); setPage(1); }}>
            <div style={s.statLabel}>📅 متابعات اليوم</div>
            <div style={{ ...s.statValue, color: '#f59e0b' }}>{stats.follow_up_today || 0}</div>
          </div>
          <div style={{ ...s.statCard, borderLeft: '3px solid #10b981' }}>
            <div style={s.statLabel}>✅ مكسب</div>
            <div style={{ ...s.statValue, color: '#10b981' }}>{stats.won || 0}</div>
          </div>
          <div style={{ ...s.statCard, borderLeft: '3px solid #8b5cf6' }}>
            <div style={s.statLabel}>ديمو محجوز</div>
            <div style={{ ...s.statValue, color: '#a78bfa' }}>{stats.demo_booked || stats.funnel?.demo_scheduled || 0}</div>
          </div>
        </div>
      )}

      {/* ===== FILTERS ===== */}
      <div style={s.filtersRow}>
        <input style={{ ...s.input, minWidth: '220px' }} placeholder="🔍 بحث..." value={search} onChange={(e) => setSearch(e.target.value)} />
        <select style={s.select} value={statusFilter} onChange={(e) => { setStatusFilter(e.target.value); setPage(1); }}>
          <option value="">كل الحالات</option>
          <option value="new">جديد</option>
          <option value="contacted">تم التواصل</option>
          <option value="demo_scheduled">ديمو محجوز</option>
          <option value="demo_done">ديمو تم</option>
          <option value="negotiation">تفاوض</option>
          <option value="won">كسبناه</option>
          <option value="lost">خسرناه</option>
        </select>
        <select style={s.select} value={interestFilter} onChange={(e) => { setInterestFilter(e.target.value); setPage(1); }}>
          <option value="">كل المستويات</option>
          <option value="hot">🔥 ساخن</option>
          <option value="warm">🟡 دافئ</option>
          <option value="cold">🔵 بارد</option>
        </select>
        <select style={{ ...s.select, borderColor: followUpFilter ? '#f59e0b' : undefined }} value={followUpFilter} onChange={(e) => { setFollowUpFilter(e.target.value); setPage(1); }}>
          <option value="">كل المتابعات</option>
          <option value="overdue">⏰ متأخرة</option>
          <option value="today">📅 اليوم</option>
          <option value="upcoming">🔜 هذا الأسبوع</option>
          <option value="none">❌ بدون متابعة</option>
        </select>
        <select style={s.select} value={countryFilter} onChange={(e) => { setCountryFilter(e.target.value); setPage(1); }}>
          <option value="">كل الدول</option>
          <option value="965">🇰🇼 الكويت</option>
          <option value="966">🇸🇦 السعودية</option>
          <option value="20">🇪🇬 مصر</option>
          <option value="other">🌍 أخرى</option>
        </select>
      </div>

      {/* ===== TABLE ===== */}
      <div style={s.tableWrap}>
        <table style={s.table}>
          <thead><tr>
            <th style={s.th}>#</th>
            <th style={s.th}>العميل</th>
            <th style={s.th}>الشركة</th>
            <th style={s.th}>الرقم</th>
            <th style={s.th}>الاهتمام</th>
            <th style={s.th}>الحالة</th>
            <th style={s.th}>المتابعة</th>
            <th style={s.th}>التاريخ</th>
            <th style={{ ...s.th, textAlign: 'center' }}>إجراءات</th>
          </tr></thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={9} style={{ ...s.td, textAlign: 'center', padding: '40px' }}>⏳ جارٍ التحميل...</td></tr>
            ) : leads.length === 0 ? (
              <tr><td colSpan={9} style={{ textAlign: 'center', padding: '60px', color: '#9ca3af' }}>
                <div style={{ fontSize: '40px', marginBottom: '12px' }}>📭</div>
                <div>لا يوجد leads</div>
              </td></tr>
            ) : leads.map((lead) => (
              <tr key={lead.id} style={{ transition: 'background 0.15s' }}
                onMouseOver={(e) => e.currentTarget.style.background = 'rgba(99,102,241,0.08)'}
                onMouseOut={(e) => e.currentTarget.style.background = 'transparent'}>
                <td style={s.td}>{lead.id}</td>
                <td style={{ ...s.td, fontWeight: '600', color: '#f9fafb', cursor: 'pointer' }} onClick={() => openLead(lead)}>{lead.customer_name || 'غير معروف'}</td>
                <td style={s.td}>{lead.company_name || '-'}</td>
                <td style={{ ...s.td, direction: 'ltr', fontFamily: 'monospace', fontSize: '12px' }}>{flag(lead.phone_number)} {lead.phone_number || '-'}</td>
                <td style={s.td}>{interestBadge(lead.interest_level)}</td>
                <td style={s.td}>{statusBadge(lead.status)}</td>
                <td style={s.td}>
                  {lead.follow_up_urgency ? (
                    <div>
                      <span style={s.fuBadge(lead.follow_up_urgency)}>{fuLabel(lead.follow_up_urgency)}</span>
                      <div style={{ fontSize: '11px', color: '#64748b', marginTop: '2px' }}>{fmtShortDate(lead.next_follow_up)}</div>
                    </div>
                  ) : lead.next_follow_up ? (
                    <span style={{ fontSize: '11px', color: '#64748b' }}>{fmtShortDate(lead.next_follow_up)}</span>
                  ) : (
                    <span style={{ fontSize: '11px', color: '#374151' }}>-</span>
                  )}
                </td>
                <td style={{ ...s.td, fontSize: '12px', whiteSpace: 'nowrap' }}>{fmtDate(lead.created_at)}</td>
                <td style={{ ...s.td, textAlign: 'center' }}>
                  <div style={{ display: 'flex', gap: '4px', justifyContent: 'center', flexWrap: 'nowrap' }}>
                    <button onClick={(e) => openWhatsApp(lead, e)} style={{ ...s.qBtn, background: 'rgba(37,211,102,0.15)', color: '#25d366' }} title="واتساب">💬</button>
                    <button onClick={(e) => { e.stopPropagation(); openLead(lead, 'details'); }} style={{ ...s.qBtn, background: 'rgba(59,130,246,0.15)', color: '#60a5fa' }} title="تعديل">✏️</button>
                    <button onClick={(e) => { e.stopPropagation(); openLead(lead, 'notes'); }} style={{ ...s.qBtn, background: 'rgba(139,92,246,0.15)', color: '#a78bfa', position: 'relative' }} title="ملاحظات">
                      📝
                      {lead.notes_count > 0 && <span style={{ background: '#8b5cf6', borderRadius: '50%', width: '15px', height: '15px', fontSize: '9px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: '700', position: 'absolute', top: '-4px', right: '-4px' }}>{lead.notes_count}</span>}
                    </button>
                    <button onClick={(e) => { e.stopPropagation(); openLead(lead, 'followup'); }} style={{ ...s.qBtn, background: 'rgba(245,158,11,0.15)', color: '#f59e0b' }} title="متابعة">⏰</button>
                    <button onClick={(e) => bookDemo(lead, e)} style={{ ...s.qBtn, background: 'rgba(16,185,129,0.15)', color: '#10b981' }} title="حجز ديمو">📅</button>
                    <button onClick={(e) => { e.stopPropagation(); setSelectedLead(lead); setShowDeleteConfirm(true); }} style={{ ...s.qBtn, background: 'rgba(239,68,68,0.1)', color: '#ef4444' }} title="حذف">🗑️</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {pagination.total_pages > 1 && (
          <div style={s.pagination}>
            <span style={{ fontSize: '13px', color: '#9ca3af' }}>صفحة {pagination.page} من {pagination.total_pages} ({pagination.total})</span>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button style={{ ...s.qBtn, ...s.btnS, padding: '6px 14px' }} disabled={page <= 1} onClick={() => setPage(p => Math.max(1, p - 1))}>← السابق</button>
              <button style={{ ...s.qBtn, ...s.btnS, padding: '6px 14px' }} disabled={page >= pagination.total_pages} onClick={() => setPage(p => p + 1)}>التالي →</button>
            </div>
          </div>
        )}
      </div>

      {/* ===== ADD LEAD MODAL (Bilingual) ===== */}
      {showAddModal && (
        <div style={s.overlay} onClick={() => setShowAddModal(false)}>
          <div style={{ ...s.modal, maxWidth: '600px', direction: addLang === 'ar' ? 'rtl' : 'ltr' }} onClick={(e) => e.stopPropagation()}>
            <div style={s.modalTitle}>
              <span>{t.title}</span>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {/* Language Toggle Button */}
                <button
                  onClick={() => setAddLang(addLang === 'ar' ? 'en' : 'ar')}
                  style={{
                    background: 'rgba(99,102,241,0.15)', border: '1px solid rgba(99,102,241,0.3)',
                    color: '#818cf8', borderRadius: '8px', padding: '6px 14px',
                    fontSize: '13px', fontWeight: '600', cursor: 'pointer',
                    display: 'flex', alignItems: 'center', gap: '6px',
                    transition: 'all 0.2s'
                  }}
                  onMouseOver={e => { e.currentTarget.style.background = 'rgba(99,102,241,0.3)'; }}
                  onMouseOut={e => { e.currentTarget.style.background = 'rgba(99,102,241,0.15)'; }}
                >
                  🌐 {addLang === 'ar' ? 'EN' : 'عربي'}
                </button>
                <button onClick={() => setShowAddModal(false)} style={s.closeBtn}>✕</button>
              </div>
            </div>

            {/* Error */}
            {addError && (
              <div style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: '8px', padding: '12px', marginBottom: '16px', color: '#ef4444', fontSize: '13px' }}>
                ⚠️ {addError}
              </div>
            )}

            {/* Row 1: Name + Phone */}
            <div style={s.row}>
              <div style={s.field}>
                <label style={s.label}>{t.customer_name}</label>
                <input style={{ ...s.input, width: '100%' }} placeholder={t.ph_name}
                  value={newLead.customer_name} onChange={e => setNewLead({...newLead, customer_name: e.target.value})} />
              </div>
              <div style={s.field}>
                <label style={s.label}>{t.phone} <span style={{ color: '#ef4444' }}>*</span></label>
                <input style={{ ...s.input, width: '100%', direction: 'ltr', fontFamily: 'monospace' }} placeholder={t.ph_phone}
                  value={newLead.phone_number} onChange={e => setNewLead({...newLead, phone_number: e.target.value})} />
              </div>
            </div>

            {/* Row 2: Company + Email */}
            <div style={s.row}>
              <div style={s.field}>
                <label style={s.label}>{t.company}</label>
                <input style={{ ...s.input, width: '100%' }} placeholder={t.ph_company}
                  value={newLead.company_name} onChange={e => setNewLead({...newLead, company_name: e.target.value})} />
              </div>
              <div style={s.field}>
                <label style={s.label}>{t.email}</label>
                <input type="email" style={{ ...s.input, width: '100%', direction: 'ltr' }} placeholder={t.ph_email}
                  value={newLead.email} onChange={e => setNewLead({...newLead, email: e.target.value})} />
              </div>
            </div>

            {/* Row 3: Interest + Industry */}
            <div style={s.row}>
              <div style={s.field}>
                <label style={s.label}>{t.interest}</label>
                <select style={{ ...s.input, width: '100%', cursor: 'pointer' }}
                  value={newLead.interest_level} onChange={e => setNewLead({...newLead, interest_level: e.target.value})}>
                  <option value="hot">{t.hot}</option>
                  <option value="warm">{t.warm}</option>
                  <option value="cold">{t.cold}</option>
                </select>
              </div>
              <div style={s.field}>
                <label style={s.label}>{t.industry}</label>
                <input style={{ ...s.input, width: '100%' }} placeholder={t.ph_industry}
                  value={newLead.industry} onChange={e => setNewLead({...newLead, industry: e.target.value})} />
              </div>
            </div>

            {/* Row 4: Size + Source */}
            <div style={s.row}>
              <div style={s.field}>
                <label style={s.label}>{t.size}</label>
                <select style={{ ...s.input, width: '100%', cursor: 'pointer' }}
                  value={newLead.company_size} onChange={e => setNewLead({...newLead, company_size: e.target.value})}>
                  <option value="">{t.choose}</option>
                  <option value="1-5">{t.s1}</option>
                  <option value="6-20">{t.s2}</option>
                  <option value="21-50">{t.s3}</option>
                  <option value="51-100">{t.s4}</option>
                  <option value="100+">{t.s5}</option>
                </select>
              </div>
              <div style={s.field}>
                <label style={s.label}>{t.source}</label>
                <select style={{ ...s.input, width: '100%', cursor: 'pointer' }}
                  value={newLead.source} onChange={e => setNewLead({...newLead, source: e.target.value})}>
                  <option value="manual">{t.src_manual}</option>
                  <option value="phone_call">{t.src_call}</option>
                  <option value="whatsapp">{t.src_wa}</option>
                  <option value="website">{t.src_web}</option>
                  <option value="referral">{t.src_ref}</option>
                  <option value="social_media">{t.src_social}</option>
                  <option value="exhibition">{t.src_expo}</option>
                  <option value="other">{t.src_other}</option>
                </select>
              </div>
            </div>

            {/* Needs Summary */}
            <div style={s.field}>
              <label style={s.label}>{t.needs}</label>
              <textarea style={{ ...s.textarea, minHeight: '60px' }} placeholder={t.ph_needs}
                value={newLead.needs_summary} onChange={e => setNewLead({...newLead, needs_summary: e.target.value})} />
            </div>

            {/* Notes */}
            <div style={s.field}>
              <label style={s.label}>{t.notes}</label>
              <textarea style={{ ...s.textarea, minHeight: '50px' }} placeholder={t.ph_notes}
                value={newLead.notes} onChange={e => setNewLead({...newLead, notes: e.target.value})} />
            </div>

            {/* Buttons */}
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '8px' }}>
              <button onClick={() => setShowAddModal(false)} style={s.btnS}>{t.cancel}</button>
              <button onClick={handleAddLead} disabled={addingLead}
                style={{
                  ...s.btnP,
                  background: addingLead ? 'rgba(99,102,241,0.3)' : 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                  cursor: addingLead ? 'not-allowed' : 'pointer', padding: '10px 28px'
                }}
              >
                {addingLead ? t.saving : t.save}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== EDIT MODAL (3 Tabs) ===== */}
      {showModal && selectedLead && (
        <div style={s.overlay} onClick={() => setShowModal(false)}>
          <div style={s.modal} onClick={(e) => e.stopPropagation()}>
            <div style={s.modalTitle}>
              <span>🛒 Lead #{selectedLead.id} - {selectedLead.customer_name || 'غير معروف'}</span>
              <button onClick={() => setShowModal(false)} style={s.closeBtn}>✕</button>
            </div>

            <div style={s.tabBar}>
              <button style={{ ...s.tab, ...(modalTab === 'details' ? s.tabA : {}) }} onClick={() => handleTabChange('details')}>✏️ التفاصيل</button>
              <button style={{ ...s.tab, ...(modalTab === 'notes' ? s.tabA : {}) }} onClick={() => handleTabChange('notes')}>📝 ملاحظات {notes.length > 0 ? `(${notes.length})` : ''}</button>
              <button style={{ ...s.tab, ...(modalTab === 'followup' ? s.tabA : {}) }} onClick={() => setModalTab('followup')}>⏰ متابعة</button>
            </div>

            {/* TAB: Details */}
            {modalTab === 'details' && (<>
              <div style={s.row}>
                <div style={s.field}><label style={s.label}>اسم العميل</label><input style={s.input} value={editData.customer_name||''} onChange={e => setEditData({...editData, customer_name: e.target.value})} /></div>
                <div style={s.field}><label style={s.label}>الشركة</label><input style={s.input} value={editData.company_name||''} onChange={e => setEditData({...editData, company_name: e.target.value})} /></div>
              </div>
              <div style={s.row}>
                <div style={s.field}><label style={s.label}>رقم الهاتف</label><input style={{...s.input, direction:'ltr', fontFamily:'monospace'}} value={editData.phone_number||''} onChange={e => setEditData({...editData, phone_number: e.target.value})} /></div>
                <div style={s.field}><label style={s.label}>حجم الشركة</label><input style={s.input} value={editData.company_size||''} onChange={e => setEditData({...editData, company_size: e.target.value})} /></div>
              </div>
              <div style={s.row}>
                <div style={s.field}><label style={s.label}>النشاط</label><input style={s.input} value={editData.industry||''} onChange={e => setEditData({...editData, industry: e.target.value})} /></div>
                <div style={s.field}><label style={s.label}>الميزانية</label><input style={s.input} value={editData.budget_range||''} onChange={e => setEditData({...editData, budget_range: e.target.value})} /></div>
              </div>
              <div style={s.row}>
                <div style={s.field}><label style={s.label}>الحالة</label>
                  <select style={s.input} value={editData.status||''} onChange={e => setEditData({...editData, status: e.target.value})}>
                    <option value="new">جديد</option><option value="contacted">تم التواصل</option><option value="demo_scheduled">ديمو محجوز</option><option value="demo_done">ديمو تم</option><option value="negotiation">تفاوض</option><option value="won">كسبناه ✅</option><option value="lost">خسرناه ❌</option>
                  </select>
                </div>
                <div style={s.field}><label style={s.label}>مستوى الاهتمام</label>
                  <select style={s.input} value={editData.interest_level||''} onChange={e => setEditData({...editData, interest_level: e.target.value})}>
                    <option value="hot">🔥 ساخن</option><option value="warm">🟡 دافئ</option><option value="cold">🔵 بارد</option>
                  </select>
                </div>
              </div>
              <div style={s.row}>
                <div style={s.field}><label style={s.label}>المصدر</label><input style={s.input} value={editData.source||''} onChange={e => setEditData({...editData, source: e.target.value})} /></div>
                <div style={s.field}><label style={s.label}>موعد الديمو</label><input type="datetime-local" style={s.input} value={editData.demo_date||''} onChange={e => setEditData({...editData, demo_date: e.target.value})} /></div>
              </div>
              <div style={s.field}><label style={s.label}>الموديولات المطلوبة</label><input style={s.input} value={editData.interested_modules||''} onChange={e => setEditData({...editData, interested_modules: e.target.value})} /></div>
              <div style={s.field}><label style={s.label}>ملخص الاحتياج</label><textarea style={s.textarea} value={editData.needs_summary||''} onChange={e => setEditData({...editData, needs_summary: e.target.value})} /></div>
              {selectedLead.messages?.length > 0 && (
                <div style={s.field}>
                  <label style={s.label}>المحادثة ({selectedLead.messages.length} رسالة)</label>
                  <div style={{ background: 'rgba(10,14,39,0.5)', borderRadius: '8px', padding: '12px', maxHeight: '200px', overflowY: 'auto' }}>
                    {selectedLead.messages.map((m, i) => (
                      <div key={i} style={{ padding: '6px 10px', borderRadius: '8px', marginBottom: '5px', fontSize: '12px', maxWidth: '85%', background: m.message_type === 'customer' ? 'rgba(16,185,129,0.1)' : 'rgba(99,102,241,0.1)', marginLeft: m.message_type === 'customer' ? 0 : 'auto', marginRight: m.message_type === 'customer' ? 'auto' : 0, color: '#d1d5db', direction: 'rtl' }}>
                        <div style={{ fontSize: '10px', color: '#9ca3af', marginBottom: '3px' }}>{m.message_type === 'customer' ? '👤' : '🤖'} {fmtDate(m.created_at)}</div>
                        {m.message_text}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'space-between', marginTop: '20px' }}>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button style={s.btnD} onClick={() => setShowDeleteConfirm(true)}>🗑️ حذف</button>
                  <button onClick={() => bookDemo(null)} style={{ background: 'rgba(16,185,129,0.15)', color: '#10b981', border: '1px solid rgba(16,185,129,0.3)', borderRadius: '8px', padding: '10px 16px', fontSize: '14px', fontWeight: '500', cursor: 'pointer' }}>📅 حجز ديمو</button>
                </div>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <button style={s.btnS} onClick={() => setShowModal(false)}>إلغاء</button>
                  <button style={s.btnP} onClick={saveLead} disabled={saving}>{saving ? '⏳...' : '💾 حفظ'}</button>
                </div>
              </div>
            </>)}

            {/* TAB: Notes */}
            {modalTab === 'notes' && (<>
              <div style={{ marginBottom: '20px' }}>
                <textarea value={newNote} onChange={e => setNewNote(e.target.value)} placeholder="اكتب ملاحظة جديدة..." rows={3} style={{ ...s.textarea, marginBottom: '10px' }} onKeyDown={e => { if (e.key === 'Enter' && e.ctrlKey) addNote(); }} />
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: '11px', color: '#64748b' }}>Ctrl+Enter للإرسال</span>
                  <button onClick={addNote} disabled={!newNote.trim() || addingNote} style={{ ...s.btnP, padding: '8px 18px', fontSize: '13px', opacity: (!newNote.trim() || addingNote) ? 0.5 : 1 }}>{addingNote ? '⏳...' : '➕ إضافة'}</button>
                </div>
              </div>
              {notesLoading ? <div style={{ textAlign: 'center', color: '#9ca3af', padding: '30px' }}>⏳...</div>
              : notes.length === 0 ? <div style={{ textAlign: 'center', color: '#64748b', padding: '40px' }}><div style={{ fontSize: '36px', marginBottom: '10px' }}>📋</div>لا توجد ملاحظات</div>
              : <>{notes.map(n => (
                <div key={n.id} style={s.noteCard}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                    <div><span style={{ color: '#60a5fa', fontSize: '13px', fontWeight: '600' }}>{n.agent_name || '?'}</span><span style={{ color: '#4b5563', margin: '0 8px' }}>•</span><span style={{ color: '#6b7280', fontSize: '12px' }}>{fmtDate(n.created_at)}</span></div>
                    <button onClick={() => deleteNote(n.id)} style={{ background: 'none', border: 'none', color: '#6b7280', cursor: 'pointer', fontSize: '14px' }} onMouseOver={e => e.target.style.color='#ef4444'} onMouseOut={e => e.target.style.color='#6b7280'}>🗑️</button>
                  </div>
                  <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.7', color: '#d1d5db', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{n.note}</p>
                </div>
              ))}</>}
            </>)}

            {/* TAB: Follow-up */}
            {modalTab === 'followup' && (<>
              {selectedLead.next_follow_up && (
                <div style={{ background: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.2)', borderRadius: '10px', padding: '16px', marginBottom: '20px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                    <span style={{ color: '#f59e0b', fontWeight: '600', fontSize: '14px' }}>📅 متابعة مجدولة</span>
                    <button onClick={() => completeFollowUp(false)} style={{ ...s.qBtn, background: 'rgba(16,185,129,0.15)', color: '#10b981', padding: '6px 14px', fontSize: '13px' }}>✅ تمت المتابعة</button>
                  </div>
                  <div style={{ color: '#f9fafb', fontSize: '15px' }}>{fmtDate(selectedLead.next_follow_up)}</div>
                  {selectedLead.follow_up_note && <div style={{ color: '#9ca3af', fontSize: '13px', marginTop: '4px' }}>{selectedLead.follow_up_note}</div>}
                </div>
              )}
              <div style={{ background: 'rgba(26,32,56,0.6)', borderRadius: '10px', padding: '20px', border: '1px solid rgba(255,255,255,0.06)' }}>
                <h4 style={{ color: '#f9fafb', margin: '0 0 16px', fontSize: '15px' }}>{selectedLead.next_follow_up ? '📝 تعديل / إعادة جدولة' : '➕ جدولة متابعة جديدة'}</h4>
                <div style={s.field}><label style={s.label}>تاريخ ووقت المتابعة</label><input type="datetime-local" style={s.input} value={fuDate} onChange={e => setFuDate(e.target.value)} /></div>
                <div style={s.field}><label style={s.label}>ملاحظة المتابعة</label><textarea style={{ ...s.textarea, minHeight: '60px' }} value={fuNote} onChange={e => setFuNote(e.target.value)} placeholder="مثال: تأكيد موعد الديمو..." /></div>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '16px' }}>
                  {[
                    { label: 'بعد ساعة', h: 1 }, { label: 'غداً 10ص', d: 1, hour: 10 }, { label: 'غداً 2م', d: 1, hour: 14 },
                    { label: 'بعد 3 أيام', d: 3, hour: 10 }, { label: 'بعد أسبوع', d: 7, hour: 10 }
                  ].map((q, i) => {
                    const dt = new Date();
                    if (q.h) dt.setHours(dt.getHours() + q.h);
                    if (q.d) { dt.setDate(dt.getDate() + q.d); dt.setHours(q.hour, 0, 0, 0); }
                    const val = dt.toISOString().slice(0, 16);
                    return <button key={i} onClick={() => setFuDate(val)} style={{ ...s.qBtn, background: 'rgba(99,102,241,0.1)', color: '#818cf8', padding: '5px 12px', fontSize: '12px', border: '1px solid rgba(99,102,241,0.2)', borderRadius: '20px' }}>{q.label}</button>;
                  })}
                </div>
                <button onClick={saveFollowUp} disabled={!fuDate || fuSaving} style={{ ...s.btnP, width: '100%', opacity: (!fuDate || fuSaving) ? 0.5 : 1 }}>{fuSaving ? '⏳...' : '📅 حفظ المتابعة'}</button>
              </div>
              <div style={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
                <button onClick={(e) => openWhatsApp(selectedLead, e)} style={{ ...s.btnS, flex: 1, color: '#25d366', borderColor: 'rgba(37,211,102,0.3)' }}>💬 راسله واتساب</button>
                <button onClick={() => { if(selectedLead.phone_number) { window.open(`tel:${selectedLead.phone_number}`); axios.post(`${API}/leads/${selectedLead.id}/log-contact`, { method: 'call' }, { headers }).catch(()=>{}); }}} style={{ ...s.btnS, flex: 1, color: '#60a5fa', borderColor: 'rgba(59,130,246,0.3)' }}>📞 اتصل</button>
              </div>
            </>)}

            {/* DELETE CONFIRM OVERLAY */}
            {showDeleteConfirm && (
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(10,14,39,0.95)', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10 }}>
                <div style={{ textAlign: 'center', padding: '20px' }}>
                  <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
                  <h3 style={{ color: '#f9fafb', margin: '0 0 12px' }}>تأكيد حذف Lead #{selectedLead?.id}</h3>
                  <p style={{ color: '#9ca3af', marginBottom: '8px' }}>{selectedLead?.customer_name || 'غير معروف'} - {selectedLead?.phone_number}</p>
                  <p style={{ color: '#ef4444', fontSize: '13px', marginBottom: '20px' }}>سيتم حذف كل الملاحظات والمتابعات!</p>
                  <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                    <button onClick={() => setShowDeleteConfirm(false)} style={{ ...s.btnS, padding: '10px 28px' }}>إلغاء</button>
                    <button onClick={handleDelete} disabled={deleting} style={{ background: '#ef4444', color: '#fff', border: 'none', borderRadius: '8px', padding: '10px 28px', fontSize: '14px', fontWeight: '600', cursor: deleting ? 'not-allowed' : 'pointer', opacity: deleting ? 0.7 : 1 }}>{deleting ? '⏳...' : '🗑️ احذف'}</button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* STANDALONE DELETE (from table) */}
      {showDeleteConfirm && !showModal && selectedLead && (
        <div style={s.overlay} onClick={() => setShowDeleteConfirm(false)}>
          <div style={{ ...s.modal, maxWidth: '420px', textAlign: 'center' }} onClick={e => e.stopPropagation()}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
            <h3 style={{ color: '#f9fafb', margin: '0 0 12px' }}>تأكيد حذف Lead #{selectedLead.id}</h3>
            <p style={{ color: '#9ca3af' }}>{selectedLead.customer_name || 'غير معروف'}</p>
            <p style={{ color: '#ef4444', fontSize: '13px', marginBottom: '20px' }}>لا يمكن التراجع!</p>
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
              <button onClick={() => setShowDeleteConfirm(false)} style={{ ...s.btnS, padding: '10px 28px' }}>إلغاء</button>
              <button onClick={handleDelete} disabled={deleting} style={{ background: '#ef4444', color: '#fff', border: 'none', borderRadius: '8px', padding: '10px 28px', fontWeight: '600', cursor: deleting ? 'not-allowed' : 'pointer' }}>{deleting ? '⏳...' : '🗑️ احذف'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
    </Layout>
  );
};
export default LeadsPage;